// src/index.ts

// Main components - automatické pro jednoduché použití
export {
  DevTools, // Automatická detekce dev environment
  DevToolsLauncher, // Wrapper komponenta
  DevToolsForce, // Vždy viditelná verze
} from './components/DevToolsAuto'

// Manuální ovládání pro pokročilé použití
export { DevToolsManual } from './components/DevToolsAuto'
export { DevTools as DevToolsCore } from './components/DevTools' // Původní komponenta

// Launcher komponenty
export {
  DevToolsTrigger,
  DevToolsProvider,
  DevToolsStandalone,
  useDevTools,
  useDevToolsContext,
  withDevTools,
} from './components/DevToolsLauncher'

// Types
export type {
  Device,
  DevToolsProps,
  EnhancedLighthouseMetrics as LighthouseMetrics,
  DetailedAccessibilityIssue as AccessibilityIssue,
  ComprehensiveSEOMetrics as SEOMetrics,
  SecurityMetrics,
  PerformanceClass,
  VitalStatus,
} from './types'

// Data
export { devices, essentialDevices, deviceCategories } from './data/devices'

// Hooks
export { useDevToolsTests } from './hooks/useDevToolsTests'

// Utils
export {
  getScaleFactor,
  getPerformanceClass,
  getVitalStatus,
  getCleanUrl,
  refreshAllFrames,
} from './utils/helpers'
